import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserSecret, faUserTie, faCogs, faChevronRight, faChartBar, faFolder, faHandHoldingUsd, faHandshake, faNewspaper, faBookOpen, faCoins, faShieldAlt, faBars, faHeadset, faCalendar, faCity, faCreditCard, faDownload, faFilter, faSearch, faFileInvoice, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import authAxios from "../services/Token";
import axios from "axios";
import Swal from 'sweetalert2';
import Submenu from './Submenu';
class Menu extends React.Component {
	constructor(props) {
		super(props);
	}
	state = {
		dolarText: '',
		Modulos: [],
		SubModulos: [],
		names: [],
	}
	modulos() {
		var idu = localStorage.getItem('idusuario');
		authAxios.get("roles/modulos/" + idu)
			.then((datosRespuesta) => {
				//console.log('Menu');
				//console.log(datosRespuesta.data);
				var status = datosRespuesta.data.status;
				if (status) {
					Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
					window.localStorage.clear();
					window.location.href = '/';
				}
				this.setState({ Modulos: datosRespuesta.data.data });
			})
			.catch(console.log);
	}
	componentDidMount() {
		this.modulos();
	}
	render() {
		const { Modulos, SubModulos, names } = this.state;
		return (
			<div>
				<aside className="main-sidebar sidebar-dark-primary elevation-4">
					{/* Brand Logo */}
					<Link to="/home" className="brand-link">
						<img
							style={{ backgroundColor: "#FFFFFF", padding: "5px", borderRadius: "50%", objectFit: "cover", opacity: 1 }}
							src={process.env.PUBLIC_URL + '/dist/img/Logo TC Transport.jpeg'}
							className="brand-image img-circle elevation-3" />
						<span className="brand-text font-weight-light">TC Transport</span>
					</Link>
					{/* Sidebar */}
					<div className="sidebar">
						{/* Sidebar user panel (optional) */}
						<div className="user-panel mt-3 pb-3 mb-3 d-flex">
							<div className="image">
								<img src={process.env.PUBLIC_URL + '/dist/img/user_1144709.png'} className="img-circle elevation-2" alt="User Image" />
							</div>
							<div style={{ color: "#C2C7D0" }} className="info">
                				{window.localStorage.getItem('nombre')}
							</div>
						</div>
						<nav className="mt-2">
							<ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
								{Modulos.map((item, indexMenu) => (
									<li key={indexMenu} className="nav-item menu-close">
										<a href="#" className="nav-link">
											<FontAwesomeIcon className="fa-icon" style={{ marginRight: 15 }} icon={
												item.icon === 'faChartBar' ? faChartBar :
													item.icon === 'faFileInvoice' ? faFileInvoice :
														item.icon === 'faHandHoldingUsd' ? faHandHoldingUsd :
															item.icon === 'faCoins' ? faCoins :
																item.icon === 'faHandshake' ? faHandshake :
																	item.icon === 'faNewspaper' ? faNewspaper :
																		item.icon === 'faBookOpen' ? faBookOpen :
																			item.icon === 'faHeadset' ? faHeadset :
																				item.icon === 'faUserSecret' ? faUserSecret :
																					item.icon === 'faUserTie' ? faUserTie :
																						item.icon === 'faShieldAlt' ? faShieldAlt :
																							item.icon === 'faBars' ? faBars :
																								item.icon === 'faCalendar' ? faCalendar :
																									item.icon === 'faCity' ? faCity :
																										item.icon === 'faCoins' ? faCoins :
																											item.icon === 'faCreditCard' ? faCreditCard :
																												item.icon === 'faDownload' ? faDownload :
																													item.icon === 'faFilter' ? faFilter :
																														item.icon === 'faSearch' ? faSearch :
																															item.icon === 'faCogs' ? faCogs :
																																item.icon === 'faFileInvoiceDollar' ? faFileInvoiceDollar : faFolder
											} />
											<p>
												{item.nombre}
												<i className="right fas fa-angle-left" />
											</p>
										</a>
										<ul className="nav nav-treeview">
											{item.submenu.map((sub, indexSubMenu) => (
												<li key={indexSubMenu} className="nav-item">
													<Link to={"/" + sub.link} className="nav-link">
														<FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
														<p>{sub.titulo}</p>
													</Link>
												</li>
											))}
										</ul>
									</li>
								))}
							</ul>
						</nav>
						{/* /.sidebar-menu */}
					</div>
					{/* /.sidebar */}
				</aside>
			</div>
		)
	}
}

export default Menu;